import React, { useState, useRef, useCallback } from "react";
import PropTypes from "prop-types";

import TruncateTextWithTooltip from "shared/react_components/TruncateTextWithTooltip";

const TileTitle = props => <TruncateTextWithTooltip component="h1" {...props} />;

TileTitle.propTypes = {
  className: PropTypes.string
};

TileTitle.defaultProps = {
  className: ""
};

export default TileTitle;
